// extracted by mini-css-extract-plugin
export default {"listProjects":"list-projects-evaluation_listProjects__xki+G"};